import React from 'react';
import SectionHeader from 'Components/SectionHeader/SectionHeader';
import Container from 'Components/Container/Container';
import logo from 'assets/logo/logo.png';
import FadeInAnimation from 'Components/FadeInAnimation/FadeInAnimation';
import Reavel from 'Components/Reveal/Reavel';

const AboutUs = () => {
    return (
      <div
        className="bg-gray-700 bg-amber-400 pb-10 lg:pb-20 pt-4"
        id="aboutus"
      >
        <SectionHeader heading={"À propos"}></SectionHeader>
        <Container>
          <div className="grid grid-cols-1 gap-10">
            <FadeInAnimation>
              <div className="flex flex-col lg:flex-row-reverse justify-center items-center gap-10">
                <div className="">
                  <img
                    className="md:max-w-md max-w-sm rounded-xl"
                    loading="lazy"
                    src={logo}
                    alt="logo"
                  />
                </div>
                <div>
                  <Reavel>
                    <p className="text-white text-slate-700">
                      Bienvenue dans la{" "}
                      <span className="font-semibold">
                        Fédération Québécoise de Soccer sur Table
                      </span>
                      , c'est le début d'une nouvelle aventure passionnante.
                    </p>
                  </Reavel>
                  <Reavel>
                    <p className="text-white text-slate-700">
                    Nous avons à cœur de faire découvrir le babyfoot aux jeunes, 
                    en leur offrant une initiation à ce sport passionnant et dynamique. 
                    En plus de leur faire découvrir les règles et les techniques de base, 
                    nous créons un environnement encourageant qui leur permet de développer leurs talents. 
                    Nous croyons fermement que chaque jeune a un potentiel unique, 
                    et notre objectif est de les accompagner dans leur parcours sportif.
                    </p>
                  </Reavel>
                  <br />
                  <Reavel>
                    <p className="text-white text-slate-700">
                    Pour cela, nous mettons à leur disposition une variété de ressources, 
                    comme des séances d’entraînement, des ateliers et des conseils de joueurs expérimentés. 
                    Nous organisons également des événements et des activités qui leur permettent de s’amuser tout en apprenant. 
                    En cultivant leur passion pour le babyfoot, nous préparons ainsi la relève, 
                    en veillant à ce qu’ils acquièrent non seulement des compétences techniques, 
                    mais aussi des valeurs de camaraderie et de fair-play. Ensemble, nous bâtissons un avenir prometteur pour le babyfoot!
                    </p>
                  </Reavel>
                </div>
              </div>
            </FadeInAnimation>
            <FadeInAnimation>
              <div className="flex flex-col lg:flex-row justify-center items-center gap-10">
                {/* <div>
                  <img
                    className="md:max-w-md max-w-sm rounded-xl mx-auto"
                    loading="lazy"
                    src="https://images.unsplash.com/photo-1526232761682-d26e03ac148e?auto=format&fit=crop&q=80&w=1429&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                    alt=""
                  />
                </div> */}
                <div>
                  {/* <div className="text-white text-slate-700">
                    <Reavel>
                      <p className="font-bold text-xl mb-2">What We Offer:</p>
                    </Reavel>
                    <ul className="list-disc ps-6">
                      <Reavel>
                        <li>
                          <span className="font-semibold">
                            Expert Coaching:
                          </span>{" "}
                          Our team of experienced coaches and trainers are
                          dedicated to helping athletes reach their full
                          potential. We offer coaching in a wide range of
                          sports, from soccer and basketball to swimming and
                          athletics.
                        </li>
                      </Reavel>
                      <Reavel>
                        {" "}
                        <li>
                          <span className="font-semibold">
                            State-of-the-Art Hebdos:
                          </span>{" "}
                          {""}
                          Our world-class hebdos are designed to provide
                          athletes with the tools they need to succeed. From
                          cutting-edge equipment to well-maintained fields and
                          courts, we spare no effort in creating an ideal
                          training environment.
                        </li>
                      </Reavel>
                      <Reavel>
                        <li>
                          <span className="font-semibold">
                            Sportsmanship and Values:
                          </span>{" "}
                          We believe in the power of sports to instill values
                          like discipline, teamwork, and perseverance. Our
                          Aqbms are designed to foster not only athletic
                          prowess but also personal growth.
                        </li>
                      </Reavel>
                      <Reavel>
                        <li>
                          <span className="font-semibold">
                            Community and Support:
                          </span>{" "}
                          {""}
                          At Northern Sports Academy, we're more than a team;
                          we're a family. Our supportive community of athletes,
                          parents, and coaches creates an atmosphere of
                          encouragement and camaraderie.
                        </li>
                      </Reavel>
                    </ul>
                  </div> */}
                </div>
              </div>
            </FadeInAnimation>
          </div>
        </Container>
      </div>
    );
};

export default AboutUs;